// extracted by mini-css-extract-plugin
export default {"tablePriceColumn":"style_tablePriceColumn__5x3cb"};